import { defineComponent as _defineComponent } from 'vue'

import CompareHeader from '@/components/compare-components/compare-header/CompareHeader.vue';
import CompareLoadingContent from '@/components/compare-components/compare-loading-content/CompareLoadingContent.vue';
import MenuTabsScrollable from 'library-@/components/MenuTabs/MenuTabsScrollable.vue';
import { useI18n } from '@/composables/use-i18n';
import { Icon as PtIcon } from 'patsnap-biz';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComparePatentLoading',
  props: {
    side: {
        type: String,
        default: 'left',
    },
},
  setup(__props) {

const { side } = __props

const { t } = useI18n();



const { isSourceCustom } = useCompareUrlState();

// 假的tab
const tabsLabel = {
    ABST: t('patent-view.ABST'),
    CLMS: t('patent-view.CLMS'),
    DESC: t('patent-view.DESC'),
    IMAGES: t('patent-view.images'),
    PDF: t('patent-view.dual.pdfSource'),
};
const defaultTabs = ['ABST', 'CLMS', 'DESC', 'IMAGES', 'PDF'].map(item => {
    return {
        label: tabsLabel[item],
        key: item,
        hasAcl: true,
    };
});

return { __sfc: true,t, isSourceCustom, tabsLabel, defaultTabs, CompareHeader, CompareLoadingContent, MenuTabsScrollable, PtIcon }
}

})